import React, { useState } from 'react';
import './App.scss';
import Main from './Router.App';
import {
  FirebaseContext,
  firebaseService,
  firebaseServicePre
} from '@atresmedia/elections_modules_library/dist/dataProvider';
const defaultHost = window.location.hostname
  .replace(/www\./g, '')
  .replace(/amp\./g, '')
  .replace(/\.es/, '')
  .replace(/\.com/, '')
  .replace('localhost', 'antena3');

// Rediseño sites have subdomain removed from its document domain, replace properly to allow parent navigation
if (document.location.hash.indexOf('amp') === -1) {
  document.domain = document.domain.replace('www.', '');
}

const initializeService = process.env.REACT_APP_STAGING
  ? firebaseServicePre
  : firebaseService;
window.atresmedia_elecciones_firebase =
  window.atresmedia_elecciones_firebase || initializeService();

export const App = ({ entry }) => {
  const [host, setHost] = useState(defaultHost);

  return (
    <div className={`App ${host}`}>
      <FirebaseContext.Provider value={window.atresmedia_elecciones_firebase}>
        <Main entry={entry} host={host} setHost={setHost} />
      </FirebaseContext.Provider>
    </div>
  );
};

export default App;
